module.exports = __webpack_public_path__ + "img/pagination-desktop-plus8.6362abca.png";